export const POLICY_NOT_ACCEPTED = 'error.privacyPolicy.notAccepted'
export const EMAIL_AWAIT_CONFIRMATION = 'error.user.email.awaitingConfirmation'
export const TOKEN_EXPIRED = 'error.token.expired'
